/**
 * Company: SPHMedia
 * Description: [Renders long form video component]
 */

import VideoPlayerSticky from "@elements/Player/VideoPlayerSticky";
import { Heading } from "@sphtech/sph-web-ui/elements/Heading";
import type { LatestVideoResponse } from "@typings/Brightcove.d";
import { ReactElement, RefObject } from "react";

type LongFormVideoProps = {
  playing: LatestVideoResponse;
  containerRef: RefObject<HTMLDivElement | null>;
};

/**
 * LongFormVideo
 * Description: [Renders video player with long form video]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function LongFormVideo({
  playing,
  containerRef,
}: LongFormVideoProps): ReactElement {
  return (
    <div className="flex flex-col gap-3">
      <div className="mt-4 lg:mt-6 w-full h-0.5 bg-brand-primary"></div>
      <Heading
        Element="h2"
        className="text-text-muted text-sm font-bold leading-[150%]"
      >
        Video
      </Heading>
      <VideoPlayerSticky
        playing={playing}
        forwardedRef={containerRef}
        showDescription={true}
        variant="article_infinite_scroll"
      />
    </div>
  );
}
